<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle15')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle15') }}</h1>
    <p>{{ $t('artText15-1') }}</p>
    <p>{{ $t('artText15-2') }}</p>
    <p>{{ $t('artText15-3') }}</p>
    <p>{{ $t('artText15-4') }}</p>
    <p>{{ $t('artText15-5') }}</p>
    <p>{{ $t('artText15-6') }}</p>
    <img
      :src="`${staticUrl}/images/blog/10_Luxury_Modern_Kitchen_Design_Ideas_Brought_to_Life_with_DreamFlat.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText15-7') }}</p>
    <p>{{ $t('artText15-8') }}</p>
    <p>{{ $t('artText15-9') }}</p>
    <p>{{ $t('artText15-10') }}</p>
    <p>{{ $t('artText15-11') }}</p>
    <h2>{{ $t('artText15-12') }}</h2>
    <p>{{ $t('artText15-13') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle15')}`,
  ogTitle: `${t('artSeoTitle15')}`,
  description: `${t('artSeoDesc15')}`,
  ogDescription: `${t('artSeoDesc15')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
